import html2canvas from 'html2canvas'
import JSPDF from 'jspdf'

/**
 * @description: html to pdf
 * @param {Object} ele 【pdf dom container】
 * @param {String} pdfName 【export pdf filename】
 */
const html2pdf = (ele, pdfName) => {
  const eleW = ele.offsetWidth // 容器宽
  const eleH = ele.offsetHeight // 容器高
  const eleOffsetTop = ele.offsetTop // 容器到文档顶部的距离
  const eleOffsetLeft = ele.offsetLeft // 容器到文档最左的距离
  const canvas = document.createElement('canvas')
  let abs = 0
  // 当前可视窗口的宽度（不包含滚动条）
  const winIn = document.documentElement.clientWidth || document.body.clientWidth
  const winOut = window.innerWitdh // 当前窗口的宽度(包含滚动条)

  if (winOut > winIn) {
    abs = (winOut - winIn) / 2 // 滚动条宽度的一半
  }
  // 画布宽高放大两倍
  canvas.width = eleW * 2
  canvas.height = eleH * 2
  const ctx = canvas.getContext('2d')
  ctx.scale(2, 2)
  // 默认没横向滚动条，因为offset.left()有无滚动条的时候存在差值,所以translate的时候要去掉这个差值
  ctx.translate(-eleOffsetLeft - abs, -eleOffsetTop)
  html2canvas(ele, {
    dpi: 300,
    useCORS: true,
    scale: 2,
  }).then((cvs) => {
    const contentWidth = cvs.width
    const contentHeight = cvs.height
    // 一页pdf显示html页面生成的canvas高度
    const pageHeight = (contentWidth / 595.28) * 841.89
    // 未生成pdf的html页面高度
    let leftHeight = contentHeight
    // 页面偏移
    let position = 0
    // A4尺寸（595.28，841.89）,html页面生成的canvas在pdf中图片的宽高
    const imgWidth = 595.28
    const imgHeight = (595.28 / contentWidth) * contentHeight
    const pageData = cvs.toDataURL('image/jpeg', 1.0)
    const pdf = new JSPDF('', 'pt', 'a4')
    // 分页判断
    if (leftHeight < pageHeight) {
      pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
    } else {
      while (leftHeight > 0) {
        pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
        leftHeight -= pageHeight
        position -= 841.89
        // 避免添加空白页
        if (leftHeight > 0) {
          pdf.addPage()
        }
      }
    }
    pdf.save(pdfName)
  })
}

export default html2pdf
